/* eslint-disable */
import { createRouter, createWebHistory } from "vue-router";
import Dashboard from "../views/Dashboard/Dashboard.vue";
import Signup from "../views/Signup.vue";
import Signin from "../views/Signin.vue";
import editarPerfil from "../views/Dashboard/EditarPerfil.vue";
import NotFound from "../views/404.vue";
import Mas from "../views/Mas.vue";
import { JSEncrypt } from "jsencrypt";
import keys from "../store/keys";
import Password from "../views/Password.vue";
import listadoPacientes from "../views/HistoriaClinica/Index.vue";
import perfilPaciente from "../views/HistoriaClinica/PerfilPaciente.vue";
import atenciones from "../views/Atencion/ListadoAtencion.vue";
import dashboardAtencion from "../views/Atencion/DashboardAtencion.vue";

import example from "../views/HistoriaClinica/Example.vue";
import signosVitales from "../views/HistoriaClinica/SignosVitales.vue";

import historialDeAtencionPaciente from "../views/HistorialAtenciones/PerfilHistorialAtenciones.vue";
import seguimiento from "../views/Seguimiento/Index.vue";
import detalleEvaluar from "../views/Seguimiento/DetalleEvaluar.vue";
import recetaMedica from "../views/Receta/Index.vue";
import nuevosExamenes from "../views/Examenes/NuevosExamenes.vue";
import reportes from "../views/Reportes/Index.vue";
import certificadosv1 from "../views/Certificados/Certificado-V1.vue";
import certificadosv2 from "../views/Certificados/Certificado-V2.vue";
import reasignacion from "../views/HistoriaClinica/Reasignacion.vue";
import presentarEnTv from "../views/Turnos/Presentar-Tv.vue";
import OrdenAtenciones from "../views/Turnos/OrdenAtenciones.vue";
import Inventario from "../views/StockMedicina/Index.vue";

const routes = [
  {
    path: "/",
    name: "landing",
    component: Signin,
    meta: { layout: "full" },
  },
  {
    path: "/dashboard/mas",
    name: "mas",
    component: Mas,
    meta: {
      requiresAuth: true,
      layout: "horizontal",
      breadCrumb: "Otras opciones",
    },
  },
  {
    path: "/dashboard",
    name: "Dashboard",
    component: Dashboard,
    meta: { requiresAuth: true, layout: "horizontal", breadCrumb: "Inicio" },
  },
  {
    path: "/dashboard/listadoPacientes",
    name: "listadoPacientes",
    component: listadoPacientes,
    meta: { requiresAuth: true, layout: "horizontal", breadCrumb: "Gestionar Pacientes", requiredRole: ['administrador', 'doctor', 'enfermera'] }
  },
  {
    path: "/dashboard/example",
    name: "example",
    component: example,
    meta: { requiresAuth: true, layout: "horizontal", breadCrumb: "Es una prueba" },
  },
  {
    path: "/dashboard/turnos/presentar-en-tv",
    name: "presentar-en-tv",
    component: presentarEnTv,
    meta: { requiresAuth: true, layout: "full", breadCrumb: "Turnos" },
  },
  {
    path: "/dashboard/turnos/OrdenAtenciones",
    name: "Orden de Atenciones",
    component: OrdenAtenciones,
    meta: { requiresAuth: true, layout: "horizontal", breadCrumb: "OrdenAtenciones", requiredRole: ['administrador', 'enfermera'] }
  },
  {
    path: "/dashboard/perfilPaciente/:id", // ":id" es un parámetro dinámico
    name: "perfilPaciente",
    component: perfilPaciente,
    meta: { requiresAuth: true, layout: "horizontal", breadCrumb: "Perfil del Paciente", requiredRole: ['administrador', 'doctor', 'enfermera'] }
  },
  {
    path: "/dashboard/pacientes/reasignacion",
    name: "reasignacion",
    component: reasignacion,
    meta: { requiresAuth: true, layout: "horizontal", breadCrumb: "Reasignación de Pacientes.", requiredRole: ['administrador', 'doctor', 'enfermera'] }
  },
  {
    path: "/dashboard/signosVitales",
    name: "signosVitales",
    component: signosVitales,
    meta: { requiresAuth: true, layout: "horizontal", breadCrumb: "Signos Vitales.", requiredRole: ['administrador', 'doctor'] }
  },
  {
    path: "/dashboard/atenciones",
    name: "atenciones",
    component: atenciones,
    meta: { requiresAuth: true, layout: "horizontal", breadCrumb: "Listado de Atenciones.", requiredRole: ['administrador', 'doctor'] }
  },
  {
    path: "/dashboard/dashboardAtencion",
    name: "dashboardAtencion",
    component: dashboardAtencion,
    meta: { requiresAuth: true, layout: "horizontal", breadCrumb: "Dashboard Atención.", requiredRole: ['administrador', 'doctor'] }
  },
  {
    path: "/dashboard/paciente/historialDeAtencion",
    name: "historialDeAtencionPaciente",
    component: historialDeAtencionPaciente,
    meta: { requiresAuth: true, layout: "horizontal", breadCrumb: "Historial de atencion del Paciente.", requiredRole: ['administrador', 'doctor'] }
  },
  {
    path: "/dashboard/paciente/seguimiento",
    name: "historialSeguimiento",
    component: seguimiento,
    meta: { requiresAuth: true, layout: "horizontal", breadCrumb: "Seguimientos de Pacientes.", requiredRole: ['administrador', 'doctor'] }
  },
  {
    path: "/dashboard/paciente/receta",
    name: "recetaMedica",
    component: recetaMedica,
    meta: { requiresAuth: true, layout: "horizontal", breadCrumb: "Receta Médica.", requiredRole: ['administrador', 'doctor'] },
  },
  {
    path: "/dashboard/pacientes/NuevosExamenes",
    name: "NuevosExamenes",
    component: nuevosExamenes,
    meta: { requiresAuth: true, layout: "horizontal", breadCrumb: "Examenes Nuevos", requiredRole: ['administrador', 'doctor'] }
  },
  {
    path: "/dashboard/pacientes/certificados-v1",
    name: "certificados-v1",
    component: certificadosv1,
    meta: { requiresAuth: true, layout: "horizontal", breadCrumb: "Certificados", requiredRole: ['administrador', 'doctor'] }
  },
  {
    path: "/dashboard/pacientes/certificados-v2",
    name: "certificados-v2",
    component: certificadosv2,
    meta: { requiresAuth: true, layout: "horizontal", breadCrumb: "Certificados", requiredRole: ['administrador', 'doctor'] }
  },
  {
    path: "/dashboard/evaluacion/detalle",
    name: "detalleEvaluar",
    component: detalleEvaluar,
    meta: { requiresAuth: true, layout: "horizontal", breadCrumb: "Evaluación del Paciente.", requiredRole: ['administrador', 'doctor'] }
  },
  {
    path: "/dashboard/reportes",
    name: "reportes",
    component: reportes,
    meta: { requiresAuth: true, layout: "horizontal", breadCrumb: "Reporte de atenciones.", requiredRole: ['administrador', 'enfermera', 'doctor'] } //Controlo el rol
  },
  {
    path: "/dashboard/password",
    name: "password",
    component: Password,
    meta: { requiresAuth: true, layout: 'full' }
  },
  {
    path: "/dashboard/inventario",
    name: "inventario principal",
    component: Inventario,
    meta: { requiresAuth: true, layout: "horizontal", breadCrumb: "Gestión de inventario.", requiredRole: ['administrador', 'enfermera', 'doctor', 'bodega'] } //Controlo el rol
  },
  {
    path: "/inventario",
    name: "inventario",
    component: Inventario,
    meta: { requiresAuth: false, layout: "full", breadCrumb: "Inventario." }
  },
  {
    path: "/login",
    name: "Signin",
    component: Signin,
    meta: { layout: "full" },
  },
  {
    path: "/signup",
    name: "Signup",
    component: Signup,
    meta: { layout: "full" },
  },
  {
    path: "/dashboard/perfil",
    name: "Perfil",
    component: editarPerfil,
    meta: {
      requiresAuth: true,
      layout: "horizontal",
      breadCrumb: "Editar perfil",
    },
  },
  {
    path: "/:catchAll(.*)",
    name: "NotFound",
    component: NotFound,
    meta: { layout: "full" },
  },



];

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
  linkActiveClass: "active",
});


router.beforeEach((to, from, next) => {
  if (to.matched.some((route) => route.meta.requiresAuth)) {

    const userData = localStorage.getItem("userData");
    const user = userData;
    if (!user) {
      next("/login");
    } else {
      // Verificar si la ruta requiere un rol específico
      const requiredRole = to.meta.requiredRole;
      if (requiredRole) {
        const encryptedRole = localStorage.getItem("aut");
        const decrypt = new JSEncrypt();
        decrypt.setPrivateKey(keys.publicKeyBackoffice);
        const userRole = decrypt.decrypt(encryptedRole);

        if (Array.isArray(requiredRole) && requiredRole.includes(userRole)) {
          next();
        } else {
          next("/dashboard");
        }
      } else {
        next();
      }
    }
  } else {
    next();
  }
});


router.afterEach(() => {
  const appLoading = document.getElementById("loading-bg");
  if (appLoading) {
    appLoading.style.display = "none";
  }
});

export default router;